export default __webpack_public_path__ + "static/media/44.f5e7aa29.png";